import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";
import { GetScheduleId, InfoCalendar, responsePostSchedule } from "./interfaceSchedule";

export const getSchedule = async (id?: string): Promise<InfoCalendar> => {
    try {
        const data = await getApi(`/schedule/by-classroom/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as InfoCalendar;
    }
}


export const postNewSchedule = async (body: any): Promise<responsePostSchedule> => {
    try {
        const data = await postApi('/schedule', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as responsePostSchedule;
    }
}


export const getScheduleId = async (id: string): Promise<GetScheduleId> => {
    try {
        const data = await getApi(`/schedule/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as GetScheduleId;
    }
}



export const deleteSchedule = async (id: number): Promise<any> => {
    try {
        const data = await deleteApi(`/schedule/${id}`, id);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const patchSchedule = async (body: any, id?: string): Promise<any> => {
    try {
        const data = await patchApi(`/schedule/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}
